import React from 'react';
import Button from '../Button';
import makeIconName from '../../utils/makeIconName';
import styles from './index.module.scss';
const EventResult = ({ onClick, actionLabel, text, title, status = 'error', btnType }) => {
    return (React.createElement("div", { className: styles.resultWrap },
        React.createElement("i", { className: `${makeIconName(status, 'x64')} ${styles.icon}` }),
        React.createElement("h5", { className: styles.title }, title),
        React.createElement("span", { className: styles.text }, text),
        React.createElement(Button, { onClick: onClick, label: actionLabel, type: btnType || 'primaryBlue', btnSize: 'M' })));
};
export default EventResult;
